import PageNotFound from '@/components/mobile/404'
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
import Home from '@/components/mobile/Home'
import Dashboard from '@/components/mobile/Dashboard'
import Login from '@/components/mobile/Login'

// Public Components
import Aboutus from '@/components/mobile/Public/Aboutus'
import Contactus from '@/components/mobile/Public/Contactus'
import Privacy from '@/components/mobile/Public/Privacy'
import Terms from '@/components/mobile/Public/Terms'
import Labsignup from '@/components/mobile/Public/Labsignup'
import Phlebsignup from '@/components/mobile/Public/Phlebsignup'

// Secure Login Components
import MyResult from '@/components/mobile/Secure/MyResult'
import MyProfile from '@/components/mobile/Secure/MyProfile'
import EditProfile from '@/components/mobile/Secure/EditProfile'
import ChangePassword from '@/components/mobile/Secure/ChangePassword'

// Public Booking Components
import Test from '@/components/mobile/Book/Test'
import Lab from '@/components/mobile/Book/Lab'
import LabLocation from '@/components/mobile/Book/LabLocation'
import Appointment from '@/components/mobile/Book/Appointment'

// Secure Booking Components
import Address from '@/components/mobile/Book/Secure/Address'
import Payment from '@/components/mobile/Book/Secure/Payment'
import Success from '@/components/mobile/Book/Secure/Success'

import BlogFrame from '@/components/mobile/BlogFrame'
import Redirect from '@/components/mobile/Public/Redirect'
import LabRedirect from '@/components/mobile/Public/LabRedirect'
import ReferalSignup from '@/components/mobile/Public/ReferalSignup'
import ReferalLogin from '@/components/mobile/Public/ReferalLogin'
import ReferalInvite from '@/components/mobile/Public/ReferalInvite'
import ReferralLanding from '@/components/mobile/Public/ReferralLanding'

export default {
  routes: [
    { 
      path: '*', 
      component: PageNotFound,
      meta: {
        title: '404:Page Not Found - Labotist'
      }
    },
    {
      path: '/',
      name: 'Home',
      components: { default: Home, 'HeaderVue': HeaderVue, 'FooterVue': FooterVue },
      meta: {
        title: 'Home - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
          },
          {
            property: 'og:description',
            content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
          }
        ]
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        title: 'Home - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest | Book Test or View Results'
          },
          {
            property: 'og:description',
            content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest | Book Test or View Results'
          }
        ]
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
          },
          {
            property: 'og:description',
            content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
          }
        ]
      }
    },
    {
      path: '/signup/:referralCode',
      name: 'Login',
      component: Home,
      meta: {
        title: 'Login - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
          },
          {
            property: 'og:description',
            content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
          }
        ]
      }
    },
    {
      path: '/about-us',
      name: 'Aboutus',
      component: Aboutus,
      meta: {
        title: 'About Us - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Top notch home sample collection service provider, technology driven, temperature controlled sample tracking & monitoring.'
          },
          {
            property: 'og:description',
            content: 'Top notch home sample collection service provider, technology driven, temperature controlled sample tracking & monitoring.'
          }
        ]
      }
    },
    {
      path: '/contact-us',
      name: 'Contactus',
      component: Contactus,
      meta: {
        title: 'Contact Us - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Call us at 90256 62566 to book any lab test or learn more about services.'
          },
          {
            property: 'og:description',
            content: 'Call us at 90256 62566 to book any lab test or learn more about services.'
          }
        ]
      }
    },
    {
      path: '/privacy-policy',
      name: 'Privacy',
      component: Privacy,
      meta: {
        title: 'Privacy - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Privacy policy and terms & conditions'
          },
          {
            property: 'og:description',
            content: 'Privacy policy and terms & conditions'
          }
        ]
      }
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      meta: {
        title: 'Terms - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Privacy policy and terms & conditions'
          },
          {
            property: 'og:description',
            content: 'Privacy policy and terms & conditions'
          }
        ]
      }
    },
    {
      path: '/lab-signup',
      name: 'Labsignup',
      component: Labsignup,
      meta: {
        title: 'Lab Sign Up - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Partner with us for home sample collection services while you focus on your core business. In addition Improve your brand visibility, reach and revenue. Reduce the headache and cost of managing phlebotomy operations.'
          },
          {
            property: 'og:description',
            content: 'Partner with us for home sample collection services while you focus on your core business. In addition Improve your brand visibility, reach and revenue. Reduce the headache and cost of managing phlebotomy operations.'
          }
        ]
      }
    },
    {
      path: '/phlebotomist-signup',
      name: 'Phlebsignup',
      component: Phlebsignup,
      meta: {
        title: 'Phlebotomist Sign Up - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Partner with us full-time or part-time to earn more, work flexible hours and provide exceptional service to Patients. Become the experts through advanced training and use of technology.'
          },
          {
            property: 'og:description',
            content: 'Partner with us full-time or part-time to earn more, work flexible hours and provide exceptional service to Patients. Become the experts through advanced training and use of technology.'
          }
        ]
      }
    },
    {
      path: '/myresult',
      name: 'MyResult',
      component: MyResult,
      meta: {
        title: 'My Result - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'View results from any labs, share it easily to your doctor or family member'
          },
          {
            property: 'og:description',
            content: 'View results from any labs, share it easily to your doctor or family member'
          }
        ]
      }
    },
    {
      path: '/myprofile',
      name: 'MyProfile',
      component: MyProfile,
      meta: {
        title: 'My Profile - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
          },
          {
            property: 'og:description',
            content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
          }
        ]
      }
    },
    {
      path: '/editprofile',
      name: 'EditProfile',
      component: EditProfile,
      meta: {
        title: 'Edit Profile - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
          },
          {
            property: 'og:description',
            content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
          }
        ]
      }
    },
    {
      path: '/changepassword',
      name: 'ChangePassword',
      component: ChangePassword,
      meta: {
        title: 'Change Password - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
          },
          {
            property: 'og:description',
            content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
          }
        ]
      }
    },
    {
      path: '/test',
      name: 'Test',
      component: Test,
      meta: {
        title: 'Find Your Test | Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
          },
          {
            property: 'og:description',
            content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
          }
        ]
      }
    },
    {
      path: '/lab',
      name: 'Lab',
      component: Lab,
      meta: {
        title: 'Choose Lab - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
          },
          {
            property: 'og:description',
            content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
          }
        ]
      }
    },
    {
      path: '/appointment',
      name: 'Appointment',
      component: Appointment,
      meta: {
        title: 'Appointment Date|Time - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Book a convenient date and time for home sample collection. Our trained phlebotomist will take care of the rest. '
          },
          {
            property: 'og:description',
            content: 'Book a convenient date and time for home sample collection. Our trained phlebotomist will take care of the rest. '
          }
        ]
      }
    },
    {
      path: '/address',
      name: 'Address',
      component: Address,
      meta: {
        title: 'Select Address - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Choose a convenient location for sample collection. At home or at work. We will be there. '
          },
          {
            property: 'og:description',
            content: 'Choose a convenient location for sample collection. At home or at work. We will be there. '
          }
        ]
      }
    },
    {
      path: '/payment',
      name: 'Payment',
      component: Payment,
      meta: {
        title: 'Payment - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Choose a convenient location for sample collection. At home or at work. Make payment and create an order.  '
          },
          {
            property: 'og:description',
            content: 'Choose a convenient location for sample collection. At home or at work. Make payment and create an order.  '
          }
        ]
      }
    },
    {
      path: '/success',
      name: 'Success',
      component: Success,
      meta: {
        title: 'Success - Labotist',
        metaTags: [
          {
            name: 'description',
            content: 'Thanks for placing order with Labotist.'
          },
          {
            property: 'og:description',
            content: 'Thanks for placing order with Labotist.'
          }
        ]
      },
      props: true
    },
    {
      path: '/blog_iframe',
      name: 'BlogFrame',
      component: BlogFrame,
      meta: {
        title: 'Labotist'
      }
    },
    {
      path: '/labs/:city/:test',
      name: 'LabLocation',
      component: LabLocation,
      meta: {
        title: 'Choose Lab - Labotist',
        metaTags: [
          {
            name: 'description',
            content: ''
          },
          {
            property: 'og:description',
            content: ''
          }
        ]
      }
    },
    {
      path: '/labs/:city/:test/:location',
      name: 'LabLocation',
      component: LabLocation,
      meta: {
        title: 'Choose Lab - Labotist',
        metaTags: [
          {
            name: 'description',
            content: ''
          },
          {
            property: 'og:description',
            content: ''
          }
        ]
      }
    },
    {
      path: '/redirect/:data',
      name: 'Redirect',
      component: Redirect,
      meta: {
        title: 'Labotist'
      }
    },
    {
      path: '/redirect/:data/url/:tests',
      name: 'Redirect',
      component: Redirect,
      meta: {
        title: 'Labotist'
      }
    },
    {
      path: '/redirect/labs/:testdata',
      name: 'LabRedirect',
      component: LabRedirect,
      meta: {
        title: 'Choose Lab - Labotist'
      }
    },
    {
      path: '/referral/signup',
      name: 'ReferalSignup',
      component: ReferalSignup,
      meta: {
        title: 'Choose Lab - Labotist'
      }
    },
    {
      path: '/referral/signup/:referal_code',
      name: 'ReferalSignup',
      component: ReferalSignup,
      meta: {
        title: 'Choose Lab - Labotist'
      }
    },
    {
      path: '/referral/login',
      name: 'ReferalLogin',
      component: ReferalLogin,
      meta: {
        title: 'Choose Lab - Labotist'
      }
    },
    {
      path: '/referral/invite',
      name: 'ReferalInvite',
      component: ReferalInvite,
      meta: {
        title: 'Choose Lab - Labotist'
      }
    },
    {
      path: '/referral/landing',
      name: 'ReferralLanding',
      component: ReferralLanding,
      meta: {
        title: 'Choose Lab - Labotist'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/MobileRouter.js